module.exports = __webpack_public_path__ + "static/media/DumplingCa.7d0b1ff5.jpg";